<template>
    <div class="assignment-text-answer">
        <div
            class="ckeditor"
            v-if="canAnswer && editing">
            <ckeditor
                v-model="text"
                :editor="editor"
                :config="editorConfig"></ckeditor>
        </div>

        <design-2021-apprentice-display-html-component
            class="answer-text"
            v-if="!editing && text !== ''"
            :html-content="text">
        </design-2021-apprentice-display-html-component>

        <div
            class="assignment-unanswered"
            v-if="!editing && text === ''">
            {{ canAnswer? $t('assignment.not_yet_answered') : $t('assignment.not_answered') }}
        </div>

        <div class="answer-actions">
            <div class="button-group">
                <b-button
                    class="btn-save btn-save-answer"
                    v-if="editing"
                    variant="primary"
                    @click="onSave()"
                    :disabled="!textChanged">
                    Opslaan
                </b-button>

                <b-button
                    class="btn-assignment-answer"
                    v-if="canAnswer && !editing"
                    variant="primary"
                    @click="editing = true">
                    Beantwoorden
                </b-button>
            </div>

            <span class="word-count">Aantal woorden: {{ wordCount }}</span>
        </div>
    </div>
</template>

<script>
import { ords } from '../../../../../../app';
import ApprenticeEditor from '../../../../../../helpers/ApprenticeEditor';

const assignmentPartAnswerOrds = ords.use('assignmentPartAnswer');

export default {
    name: 'design-2021-assignment-answer-text-component',
    props: ['partIn', 'canAnswer', 'projectId'],
    data() {
        return {
            text: this.partIn.answers[0]?.text?.value ?? '',
            editor: ApprenticeEditor,
            editorConfig: {
                contentsCss: 'test',
                bodyClass: 'mybodyclass',
                toolbar: {
                    items: [
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'link',
                        'bulletedList',
                        'numberedList',
                        'blockQuote',
                        'undo',
                        'redo',
                    ],
                },
                language: this.$authUser.locale,
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
                },
            },
            editing: false,
        };
    },
    watch: {
        partIn: function (part) {
            this.text = part.answers[0]?.text?.value ?? '';
        },
    },
    computed: {
        previousText() {
            return this.partIn.answers[0]?.text?.value ?? '';
        },
        textChanged() {
            return this.text !== this.previousText;
        },
        wordCount() {
            let textArray = this.$options.filters.strip_html_tags(this.text).split(' ');
            let filteredArray = textArray.filter((word) => {
                return word.trim() !== '';
            });
            return filteredArray.length;
        },
    },
    methods: {
        onSave() {
            if (!this.textChanged) {
                return;
            }

            this.alert.saving();

            if (!this.partIn.hasAnswer()) {
                // create

                const data = {
                    value: this.text,
                    part_id: this.partIn.id,
                    project_id: this.projectId,
                };

                this.axios.post(this.routes.assignmentAnswer(), data).then(
                    (response) => {
                        this.partIn.addRelation('answers', response.data);

                        this.editing = false;
                        this.alert.success();
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            } else {
                // update

                const data = {
                    text: this.text,
                };

                this.axios.post(this.routes.assignmentAnswerTextUpdate(this.partIn.getAnswer().text.id), data).then(
                    (response) => {
                        this.partIn.getAnswer().text.update(response.data);
                        this.editing = false;
                        this.alert.success();
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            }
        },
    },
};
</script>

<style scoped lang="scss">
.assignment-text-answer {
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');
}

.assignment-unanswered {
    padding: map-get($grid-gutter-spacing, 'fifteen');
    color: $text-muted-color;
    border-radius: $border-radius-content;
    border: 1px solid $border-color;
}

.ckeditor ::v-deep {
    div.ck-toolbar {
        border-top-left-radius: $border-radius-content !important;
        border-top-right-radius: $border-radius-content !important;
    }

    .ck.ck-editor__main {
        .ck.ck-content {
            border-top: 1px solid $border-color;
            border-top-left-radius: 0;
            border-top-right-radius: 0;
            background-color: $white;
        }
    }
}

.answer-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: map-get($grid-gutter-spacing, 'fifteen') $grid-gutter-width;
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');
}

.word-count {
    font-weight: $font-weight-medium;
}

.button-group {
    flex: 1 0 auto;
    align-self: flex-start;
}
</style>
